import React from 'react';
import Icon from '@/v2/components/atoms/Icon';

import './NissanConnect.scss';

const NissanConnect = (props) => (
    <Icon iconName="NissanConnect" {...props}>
        <svg viewBox="0 0 9.76 9.75" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" {...props}>
            <g>
                <path strokeWidth={0} d="M2 1.47a1 1 0 11-1-1 1 1 0 011 1" transform="translate(0 -.48)" />
                <path strokeWidth={0} d="M5.87 1.47a1 1 0 11-1-1 1 1 0 011 1" transform="translate(0 -.48)" />
                <path strokeWidth={0} d="M9.76 1.47a1 1 0 11-2 0 1 1 0 012 0" transform="translate(0 -.48)" />
                <path strokeWidth={0} d="M2 5.35a1 1 0 11-1-1 1 1 0 011 1" transform="translate(0 -.48)" />
                <path strokeWidth={0} d="M5.87 5.35a1 1 0 11-1-1 1 1 0 011 1" transform="translate(0 -.48)" />
                <path strokeWidth={0} d="M9.76 5.35a1 1 0 11-2 0 1 1 0 012 0" transform="translate(0 -.48)" />
                <path strokeWidth={0} d="M2 9.23a1 1 0 11-1-1 1 1 0 011 1" transform="translate(0 -.48)" />
                <path strokeWidth={0} d="M5.86 9.23a1 1 0 11-1-1 1 1 0 011 1" transform="translate(0 -.48)" />
                <path strokeWidth={0} d="M9.75 9.23a1 1 0 11-1-1 1 1 0 011 1" transform="translate(0 -.48)" />
                <path strokeWidth={0} d="M4.48-.17h1v11.24h-1z" transform="rotate(-45.02 4.403 5.204)" />
            </g>
        </svg>
    </Icon>
);

export default NissanConnect;
